import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Observable, switchMap } from "rxjs";
import { environment } from "../../../../environments/environment";
import { SelectableLanguages } from "../../../models/state/profile/profile-state";

// Account endpoints on the auth server (environment.authority), not the Breece Cloud API.
// The authentication interceptor skips the authority origin, so the token is attached here.
@Injectable({
  providedIn: 'root'
})
export class AuthAccountApiService {

  private readonly http = inject(HttpClient);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  // Saves the signed-in user's language. The access token carries it from the next refresh.
  saveLanguage(language: SelectableLanguages): Observable<void> {
    return this.oidcSecurityService.getAccessToken().pipe(
      switchMap(token => this.http.post<void>(
        `${environment.authority}/api/Account/Language`,
        new HttpParams().set('language', language),
        { headers: new HttpHeaders({ Authorization: `Bearer ${token}` }) }
      ))
    );
  }
}
